// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__qtOwU","footer":"ChangeClinic_footer__2uN82"};